<template>
<div>
  <div class="content">
    <!-- <h2 class="fontweight" style="text-align:center;margin:1rem 0 .5rem;font-size:1.2rem;">专家注册协议</h2> -->
    <p class="fontweight">尊敬的专家：</p>
    <p class="textIndent">您好！在您下载注册成为好兽药APP在线共享专家（下称“专家”）并开通服务前，请务必认真阅读和理解本《专家注册协议》（下称“协议”）中规定的所有权利和义务，包括其中的免责条款，并基于以下条款和条件向客户提供线上咨询和线下预约出诊等相关服务。如果您同意接受本条款的所有协约，请勾选“同意☑”，您将成为好兽药APP在线共享专家，开展咨询、出诊等相关服务。如果您不同意接受本条款的协约，请勾选“不同意☑”，仅作为用户使用好兽药APP。</p>
    <p class="textIndent">好兽药APP是普莱柯生物工程股份有限公司针对目前畜牧兽医行业的现状和痛点，开发的一款帮助用户、专家之间建立良好生产生态圈的服务软件，致力于打造一个为养殖、生产、研发、检疫全链条服务的多元化共享平台。通过有效整合行业资源，帮助用户解决动物疫病诊断难、就医慢、损失重等难题，用户可以通过好兽药APP平台享受找专家、线上咨询、线上下单等服务。</p>
    <p class="textIndent">现诚邀全国畜牧业相关方面专家签约成为在线共享专家，为用户提供及时、便捷、高效的专业化服务。</p>
    <p class="fontweight">（一）专家构成</p>
    <p>专家包括高校科研机构的疫病防控、生产管理、实验室管理等方面专家；集团牧场的畜牧兽医专家；饲料/兽药/疫苗等企业高级服务专家；国家动物疫病防控体系官方兽医、动物诊疗机构执业兽医师或营养师，以及涵盖动物诊疗、防控、管理、营养等方面的全国精英专业人士。</p>
    <p class="fontweight">（二）专家应具备条件</p>
    <p>1.专家需具备兽医、畜牧、动物营养、遗传育种、养殖管理、牧场规划等专业资质。</p>
    <p>2.能独立公正，专业高效地解决用户问题。</p>
    <p>3.在所从事工作领域，具有一定的阅历或专业知识造诣，较丰富的临诊经验和解决问题能力。</p>
    <p>4.熟悉国家有关法律、法规和政策，掌握相关技术规范和要求。</p>
    <p>5.认可好兽药APP的企业文化，认同好兽药APP的业务模式。</p>
    <p class="fontweight">（三）专家服务范围</p>
    <p>1.开展动物疫病诊断、治疗、防控的在线咨询、电话问诊和预约出诊服务。</p>
    <p>2.给予用户样本检测后报告在线解读、技术指导相关服务工作。</p>
    <p>3.开展兽医职业教育的在线授课和技术交流工作。</p>
    <p class="fontweight">（四）专家认证方式</p>
    <p>专家须按照好兽药APP专家认证流程提交相关资质证明，核验时间为4小时（工作时间）。通过后专家须开通相关服务模块，才能正常开展相关服务工作。</p>
    <p class="fontweight">（五）专家权利</p>
    <p>1.接受聘请，为客户提供专业技术服务。</p>
    <p>2.依法合规地独立开展咨询服务工作。</p>
    <p>3.提出专业技术方案前，有权获得相关背景资料（不涉及客户隐私），并对背景资料保密。</p>
    <p>4.对开展的工作提出专业性意见，针对客户问题给予专业解决方案。</p>
    <p>5.获得相关的劳动服务报酬。</p>
    <p class="fontweight">（六）专家义务</p>
    <p>1.专家应遵守国家相关的法律法规。</p>
    <p>2.恪守职业道德，公正、公平、客观、科学地完成工作。</p>
    <p>3.对所提供的建议和方案进行风险评估，并明确告知用户。</p>
    <p>4.对工作内容保密，不得泄露客户信息。</p>
    <p class="fontweight">（七）专家资格认定和终止</p>
    <p>1.专家应按照好兽药APP的要求填写个人资料，提供肖像和相关证明材料完成注册。</p>
    <p>2.专家获得相关劳动服务报酬由平台统计后按相关制度执行。</p>
    <p>3.专家由下列行为或原因之一的，好兽药APP有权随时终止其好兽药APP平台专家资格：</p>
    <p>(1)	违反国家法律法规和政策。</p>
    <p>(2)	泄露受聘期间的商业秘密、技术秘密以及其他不允许公开的事宜。</p>
    <p>(3)	履行职责过程中违反职业道德，存在弄虚作假、不客观、不公正等行为。</p>
    <p>(4)	不能胜任相关工作。</p>
    <p>(5)	因个人原因，经本人申请不再担任专家。</p>
    <p>(6)	连续六个月以上不登录且未开启APP在线咨询等相关服务。</p>
    <p>(7)	客户满意度低。</p>
    <p>(8)	其他不适合继续担任专家的事项。</p>
    <p class="fontweight">（八）法律责任与免责</p>
    <p>1.好兽药APP有随时自行修改或中断软件授权而不需通知专家的权利。</p>
    <p>2.专家因不可抗因素出现的服务耽搁、延误、取消等事项，专家可以不承担法律责任。</p>
    <p>3.客户因个人言行对好兽药APP和专家等造成任何的损失，好兽药APP和专家有权进行维权并追回损失。</p>
    <p>4.专家违反相关服务条款的规定，导致或产生的任何第三方主张的任何损失、要求和索赔，包括律师费，好兽药APP不承担法律责任。专家因个人言行对好兽药APP和客户等造成任何的损失，好兽药APP有权进行维权并追回损失。</p>
    <p>5.使用好兽药APP可能会受到各个环节不稳定因素的影响，存在因不可抗力、计算机病毒、黑客攻击、系统不稳定以及其他任何网络技术、通信线路信息安全管理措施等原因造成专家的经济损失，好兽药APP及合作单位不承担法律责任。</p>
    <p>6.因技术故障等不可抗事件影响到服务的正常运行的，好兽药APP及合作单位承诺在第一时内与相关单位进行协调，及时处理进行修复，但专家因此而遭受的一切损失，好兽药APP及合作单位不承担法律责任。</p>
    <p>7.本《协议》的解释、效力及纠纷的解决，适用于中华人民共和国法律，如存在争议或纠纷首先应友好协商解决，协商不成的，双方同意将纠纷或争议提交好兽药APP所在地即北京有管辖权的人民法院管辖。</p>
    <p>8.本《协议》版权归普莱柯生物工程股份有限公司所有。</p>
    <p style="text-align:right;padding-top:0.2rem" class="fontweight">普莱柯生物工程股份有限公司</p>
    <p style="text-align:right;padding-top:0.05rem" class="fontweight">2020年10月</p>
  </div>
</div>
</template>

<script>
export default {
  name: 'authentication',
}
</script>

<style scoped>
  .content {
    line-height: 20px;
    padding: 20px;
    font-size: 0;
    text-align: left;
  }
  .textIndent{
    font-size: 12px;
    text-indent: 20px;
  }
  p{
    font-size: 12px;
    margin-bottom: 5px;
  }
  .fontweight{
    font-size: 14px;
    font-weight: 600;
  }
</style>